const SOCIAL_HOSTS = [
  'facebook.com',
  'fb.com',
  'twitter.com',
  'x.com',
  'instagram.com',
  'youtube.com',
  'youtu.be',
  'tiktok.com',
  'linkedin.com',
  'pinterest.com',
  't.me',
  'telegram.me',
  'vk.com',
  'ok.ru',
  'reddit.com',
  'discord.com',
  'discord.gg',
];

function isHttpUrl(href: string): boolean {
  return /^https?:\/\//i.test(href) || href.startsWith('//');
}

function parseHttpUrl(href: string): URL | null {
  try {
    if (href.startsWith('//')) return new URL(`https:${href}`);
    if (/^https?:\/\//i.test(href)) return new URL(href);
    return null;
  } catch {
    return null;
  }
}

function getInternalHosts(): Set<string> {
  const hosts = new Set<string>(['hotlistcasino.com', 'www.hotlistcasino.com', 'localhost', '127.0.0.1']);
  const envSiteUrl = String(process.env.NEXT_PUBLIC_SITE_URL ?? '').trim();
  if (envSiteUrl) {
    try {
      const host = new URL(envSiteUrl).hostname.toLowerCase();
      hosts.add(host);
      hosts.add(host.replace(/^www\./, ''));
    } catch {
      // ignore invalid env value
    }
  }
  return hosts;
}

function isInternalHost(hostname: string): boolean {
  const host = hostname.toLowerCase().replace(/\.$/, '');
  const internalHosts = getInternalHosts();
  if (internalHosts.has(host)) return true;
  const bare = host.replace(/^www\./, '');
  return internalHosts.has(bare);
}

export function isExternalHttpLink(href: string): boolean {
  const value = String(href ?? '').trim();
  if (!value) return false;
  if (
    value.startsWith('/') ||
    value.startsWith('#') ||
    value.startsWith('?') ||
    value.startsWith('mailto:') ||
    value.startsWith('tel:')
  ) {
    return false;
  }
  if (!isHttpUrl(value)) return false;
  const parsed = parseHttpUrl(value);
  if (!parsed) return true;
  if (isInternalHost(parsed.hostname)) return false;
  return true;
}

export function isSocialExternalLink(href: string): boolean {
  const value = String(href ?? '').trim();
  if (!isExternalHttpLink(value)) return false;
  const url = parseHttpUrl(value);
  if (!url) return false;
  const host = url.hostname.toLowerCase().replace(/^www\./, '');
  return SOCIAL_HOSTS.some((socialHost) => host === socialHost || host.endsWith(`.${socialHost}`));
}

function mergeRel(existingRel: string | undefined, required: string[]): string {
  const tokens = new Set(
    String(existingRel ?? '')
      .split(/\s+/)
      .map((token) => token.trim().toLowerCase())
      .filter(Boolean)
  );
  required.forEach((token) => tokens.add(token));
  return Array.from(tokens).join(' ');
}

export function getAutoExternalRel(href: string, existingRel?: string): string | undefined {
  if (!isExternalHttpLink(href)) return existingRel;
  if (isSocialExternalLink(href)) {
    return mergeRel(existingRel, ['noopener', 'noreferrer']);
  }
  return mergeRel(existingRel, ['nofollow', 'noopener', 'noreferrer']);
}
